export const RegistryTypes = Object.freeze({
  ANONYMOUS: 0, // not backend replicated, only for frontend
  QUAY: 1,
  AZURE: 2,
  CUSTOM: 3,
  GITLAB: 4,
  PROGET: 5,
  DOCKERHUB: 6,
  ECR: 7,
});
